import React from 'react';
import Mealplanner from './community-components/Mealplanner';
import Breastfeeding from './community-components/Breastfeeding';
import "./calendar/css/calendar.css";
import Service from '../service/Service';
import Periodovulationcalculator from './community-components/Periodovulationcalculator';
import Vaccinationtracker from './community-components/Vaccinationtracker';
import Discussion from './community-components/Discussion';
import Communityquickread from './community-components/Communityquickread';
import Dietplanmom from './community-components/Dietplanmom';
import Qna from './community-components/Qna';
//import Babyteetingtool from './community-components/Babyteetingtool';
import PromotionalTools from './community-components/PromotionalTools'
import Babynames from './community-components/Babynames';
import Suggestedbabynames from './community-components/Suggestedbabynames';
import Docconnectconsultation from './community-components/Docconnectconsultation';
import Fataldevelopementvide from './community-components/Fataldevelopementvide';
import Duedatecalculator from './community-components/Duedatecalculator';
import Faceaday from './community-components/Faceaday';
import Contestandwinner from './community-components/Contestandwinner';
import Quiz from './community-components/Quiz';
import Docconnectbasedonsymptoms from './community-components/Docconnectbasedonsymptoms';
import Babysizecomparison from './community-components/Babysizecomparison';
import Babykickcounter from './community-components/Babykickcounter';
import Topgroupcategories from './community-components/Topgroupcategories';
import Milestone from './community-components/Milestone';
import Groups from './community-components/Groups';
import * as moment from 'moment';
import Articles from './highlights-components/Articles';
import Video from './highlights-components/Video';
import Writeforus from './community-components/Writeforus';
import Growthtracker from './community-components/Growthtracker';
import MagazineArticles from './community-components/MagazineArticles';
import Babythisweek from './community-components/Babythisweek';
import Memoriesview from './community-components/Memoriesview';
import Weekbyweekfataldevelopement from './community-components/Weekbyweekfataldevelopement'
import Mybumpie from './community-components/Mybumpie';
import Preganancyinspectionschedule from './highlights-components/Preganancyinspectionschedule';
import Slider from "./swiper/slider";
import "./swiper/swiper.css";





const service = new Service();

export default function ({ highlightsfeed, fashionData ,nonfashionData,eleRef }) {

  console.log("highlightsfeed =====> ", highlightsfeed);
    
    return (
        <div className="highlight_second_section"   onClick={() => sessionStorage.setItem('scrollPosition', window.scrollY)}
>  

                    
                    {highlightsfeed && highlightsfeed.map((feedItem, index) =>
                    <div key={index} id={index} className="gtm-main-data" data-type={feedItem.type} alt={`${feedItem.title}`} title={`${(feedItem.data && feedItem.data[0] && feedItem.data[0].articleTitle)?feedItem.data[0].articleTitle:'' }`} data-id={`${feedItem.groupType}_${feedItem.pageNo}_${feedItem.type}`} data-articleid={`${(feedItem.data && feedItem.data[0] && feedItem.data[0].articleId)?feedItem.data[0].articleId:'' }`} data-videotitle={`${(feedItem.data && feedItem.data[0] && feedItem.data[0].title)?feedItem.data[0].title:'' }`}>

                    {index == 6 && Array.isArray(fashionData) && fashionData.length > 0 ?
                    (
                    <div className="main_block_container_feed fc-corner-wrapper">
                      <div className='content-div-box-artical fc-corner' data-position="6" >
                                <h2 className="M18_21" role='heading' tabIndex={0} aria-label="Checkout the bestseller categories in your childs age group">
                                  Checkout the bestseller categories in your child's age group
                                </h2>
                    
                                <Slider page={"dr-carousel-unit1"} data={fashionData  ? fashionData:[]} />
                    
                    </div></div>):''}  
                    {index == 4 && Array.isArray(nonfashionData) && nonfashionData.length > 0    ?
                    (
                    <div className="main_block_container_feed fc-corner-wrapper">
                      <div className='content-div-box-artical fc-corner' data-position="4">
                                <h2 className="M18_21" role='heading' tabIndex={0} aria-label="Checkout the bestseller categories in your childs age group">
                                Checkout the bestseller categories in your child's age group
                                </h2>
                    
                                <Slider page={"dr-carousel-unit1"} data={nonfashionData  ? nonfashionData:[]} />

                    </div></div>):""}

                    {feedItem.type=="mybumpie" &&
                      <Mybumpie feedItem={feedItem} eleRef={eleRef}/>
                    }
                     
                    {feedItem.type=="writeforus" &&
                      <Writeforus highlightsfeed={feedItem} eleRef={eleRef} />
                    }

                    {feedItem.type=="growthtracker" &&
                      <Growthtracker highlightsfeed={feedItem} eleRef={eleRef}/>
                    }

                   
                    
                    {feedItem.type=="magazinesArticles" &&
                      <MagazineArticles highlightsfeed={feedItem}/>

                    }                    
                    
                    
                    {feedItem.type=="milestone" &&
                       <Milestone highlightsfeed={feedItem}/>
                    }
                    {/* END milestone */ } 
                    
                    {/* vacination */ }
                    {feedItem.type=="vaccinationtracker" && feedItem.data.length>0 &&
                        <Vaccinationtracker highlightsfeed={feedItem} />
                    }
                    {/* end vaccination*/}

                    {/*question ansar div start*/}
                    {feedItem.type=="qna" &&
                        <Qna highlightsfeed={feedItem} eleRef={eleRef} />        
                    }
                    {/* question ansar div start end*/}
                       {/* parenting tools*/}
                       {
                            feedItem.type=="preganancyinspectionschedule" &&
                            <Preganancyinspectionschedule feedItem={feedItem}/>
                        }

                    {/*meal planner div div start*/}
                    {feedItem.type=="mealplanner" &&
                        <Mealplanner highlightsfeed={feedItem}/>
                    }
                        {/* meal planner div start end*/}


                    {/* Discussion you might be div start*/}
                    {feedItem.type=="discussion" &&
                        <Discussion highlightsfeed={feedItem}/>
                    }
                    {/* Discussion you might be div end*/}

                    {/* Quick read for you  div start*/}
                    {feedItem.type=="communityquickread" &&
                        <Communityquickread highlightsfeed={feedItem}/>
                    }
                    {/* breastfeeding Moms div end*/}
                            

                   {/* Its been 2 days since you last div start*/}
                   {feedItem.type=="breastfeeding" &&
                        <Breastfeeding highlightsfeed={feedItem} eleRef={eleRef}/>             
                   }
                   {/* Its been 2 days since you last div  end*/}


                  {/* parenting tools*/}
                  {feedItem.type=="promotionalTools"  &&
                        <PromotionalTools highlightsfeed={feedItem}/>                    
                  }
                  {/* parenting tools*/}


                  {/* dight plan for div  start*/}
                  {feedItem.type=="dietplanmom" && feedItem.data && feedItem.data[0]&&
                         <Dietplanmom highlightsfeed={feedItem}/>     
                  }
                  {/* dight plan div  end*/}


                  {/* baby teething */}
                  {/* {feedItem.type=="babyteetingtool" && 
                          <Babyteetingtool highlightsfeed={feedItem}/>
                   } */}


                  { feedItem.type=="babynames" &&
                          <Babynames highlightsfeed={feedItem} />
                  }
                  {/*baby names*/}

                  {/* suggested for you div  start*/}
                  {feedItem.type=="suggestedbabynames" &&
                          <Suggestedbabynames highlightsfeed={feedItem}/>
                  }
                  {/* suggested for you div  end*/}

                  {/* online consultation  start*/}
                  {feedItem.type=="docconnectconsultation" &&
                          <Docconnectconsultation highlightsfeed={feedItem}/>
                  }
                  {/* online consultation  end*/}

                  {/* online symptoms  start*/}
                  {feedItem.type=="docconnectbasedonsymptoms" &&
                          <Docconnectbasedonsymptoms highlightsfeed={feedItem}/>
                  }
                  {/* online symptoms  end*/}


                  {/* Fetal development video div  end*/}
                  {feedItem.type=="fataldevelopementvide" &&
                          <Fataldevelopementvide highlightsfeed={feedItem} eleRef={eleRef} />
                  }
                    
                    
                    
                  {feedItem.type=="periodovulationcalculator" &&
                          <Periodovulationcalculator highlightsfeed={feedItem} eleRef={eleRef} />
                  }
                    
                    
                  {/* since you last recorded div  start*/}
                  {feedItem.type=="babykickcounter" && 
                            <Babykickcounter highlightsfeed={feedItem}/>
                  }
                  {/* since you last recorded div  end*/}


                  {/*due dates div start*/}
                  {feedItem.type=="duedatecalculator" &&
                             <Duedatecalculator highlightsfeed={feedItem}/>
                  }
                  {/* due dates div  end*/}


                  {/* baby size comp*/}
                  {feedItem.type=="Babysizecomparison" &&
                            <Babysizecomparison highlightsfeed={feedItem} eleRef={eleRef}/>
                  }                    
                  {/* baby size comp end*/}

                   {/* baby size comp*/}
                   {feedItem.type== "weekbyweekfataldevelopement" &&
                            <Weekbyweekfataldevelopement highlightsfeed={feedItem} eleRef={eleRef} />
                  }                    
                  {/* baby size comp end*/}

                      
                  {/* start face a day */}
                  {feedItem.type=="faceaday" &&
                             <Faceaday highlightsfeed={feedItem}/>
                  }
                  {/* end face a day*/}


                  {/* Contest you might be interested in div  start*/}
                  {feedItem.type=="contestandwinner" &&
                             <Contestandwinner highlightsfeed={feedItem}/>
                  }
                  {/* Contest you might be interested in div  end*/}

                        
                  {/* Top Categories div  end*/}
                  {feedItem.type=="topgroupcategories" &&
                              <Topgroupcategories highlightsfeed={feedItem}/>
                  }
                  {/* Top Categories div  end*/}

                    
                  {/* quiz start here*/}
                  {feedItem.type=="quiz" &&
                              <Quiz highlightsfeed={feedItem} eleRef={eleRef} />
                  }
                  {/*quiz end here */}

                  
                  {/*group you mightb be div start*/}
                  {feedItem.type=="Groups" &&
                    <Groups highlightsfeed={feedItem}/>
                  }

                    {/* {feedItem.type=="babythisweek" &&
                      <Babythisweek babyThisWeek={feedItem}/>
                    } */}

                  {/* group you mightb be div  end*/}

                  {feedItem.type=="milestone" &&
                    <Milestone feedItem={feedItem}/>
                  }

                  {feedItem.type=="articles" && 

                  <Articles feedItem={feedItem} GTMlike="gtm-article-like" gtmShare="gtm-article-share"  />
                  }

                  {feedItem.type=="video" &&
                  <Video feedItem={feedItem} GTMlike="gtm-video-like" gtmShare="gtm-video-share" />
                  }

                  {
                    feedItem.type=="memoriesview" &&
                    <Memoriesview feedItem={feedItem} eleRef={eleRef} />
                  }

                  </div>
                    )
                    }
        </div>
    )
}
